import { Component, Input } from "@angular/core"
import { PopoverController } from "ionic-angular"

import firebase from "firebase"

import { AppLocalStorage } from "../../services/app-local-storage"
import { UserPopover } from "../user-popover"

@Component({
  selector: "top-bar",
  templateUrl: "index.html",
})
export class TopBar {

  user: any = {}
  isLoadingPicture = true

  @Input() showUserPicture: boolean = true

  constructor(
    private popoverCtrl: PopoverController
  ) {

    this.user = AppLocalStorage.get("user")

    firebase.database().ref(`users/${firebase.auth().currentUser.uid}`)
      .on("value", (snapshot) => {

        this.user = snapshot.val()

        AppLocalStorage.set("user", this.user)
      })
  }

  showUserPopover(ev) {

    this.popoverCtrl.create(UserPopover).present({ ev })
  }
}



// WEBPACK FOOTER //
// ./src/components/top-bar/index.ts